import React from 'react';

interface QuickActionSectionProps {
  title: string;
  children: React.ReactNode;
}

export const QuickActionSection: React.FC<QuickActionSectionProps> = ({ title, children }) => (
  <section className="mt-8">
    <p className="text-white/40 text-xs font-semibold uppercase tracking-widest mb-1 px-0">
      {title}
    </p>
    <div className="divide-y divide-white/5">
      {children}
    </div>
  </section>
);
